import React, { FC, useMemo } from 'react';

import { ProviderProps } from '../types';
import ReactRouterContext from './ReactRouterContext';

const ReactRouterProvider: FC<ProviderProps> = ({ router, params, location, children }) => {
    const value = useMemo(
        () => ({
            router,
            params,
            location,
        }),
        [router, params, location],
    );

    return <ReactRouterContext.Provider value={value}>{children}</ReactRouterContext.Provider>;
};

export default ReactRouterProvider;
